export default {
    setTitle: 'setTitle',
    setShowNavbar: 'setShowNavbar',
    setNavbarColor: 'setNavbarColor',
    setShowTabbar: 'setShowTabbar',
    setGDHRSSLogin: 'setGDHRSSLogin',
    activeTabbar: 'activeTabbar',
    loadMemberAsync: 'loadMemberAsync',
    setMember: 'setMember',
    refreshMemberAsync: "refreshMemberAsync",
    loadOrderNoticeAsync: 'loadOrderNoticeAsync',
    loadOrderOptionsAsync: 'loadOrderOptionsAsync'
}